// Actions
export const setDataReferencia = ({ commit }, payload) => {
  if (typeof payload !== 'string') {
    // || !/\d{2}\/\d{2}\/\d{4}/.test(payload)
    console.error('Invalid dataReferencia value:', payload)
    if (
      payload === undefined ||
      payload === null ||
      typeof payload === 'boolean'
    ) {
      payload = ''
    }
  }
  commit('SET_DATA_REFERENCIA', payload)
}
export const setProfissionalFiltrado = ({ commit }, payload) => {
  commit('SET_PROFISSIONAL_FILTRADO', payload)
}

export const setTax = ({ commit }, payload) => {
  commit('SET_TAX', payload)
}
export const addTax = ({ commit }, payload) => {
  commit('ADD_TAX', payload)
}
export const setTaxLoading = ({ commit }, payload) => {
  commit('SET_TAX_LOADING', payload)
}

export const setAdvisorCommissions = async ({ commit }, payload) => {
  return new Promise((resolve) => {
    commit('SET_ADVISOR_COMMISSIONS', payload)
    resolve()
  })
}
export const setAdvisorCommissionsSummary = ({ commit }, payload) => {
  commit('SET_ADVISOR_COMMISSIONS_SUMMARY', payload)
}
export const setAdvisorCommissionsVisibleValues = ({ commit }, payload) => {
  commit('SET_ADVISOR_COMMISSIONS_VISIBLE_VALUES', payload)
}
export const addAdvisorCommissions = ({ commit }, payload) => {
  commit('ADD_ADVISOR_COMMISSIONS', payload)
}
export const setAdvisorCommissionsLoading = ({ commit }, payload) => {
  commit('SET_ADVISOR_COMMISSIONS_LOADING', payload)
}

export const setRules = ({ commit }, payload) => {
  commit('SET_RULES', payload)
}
export const addRules = ({ commit }, payload) => {
  commit('ADD_RULES', payload)
}
export const setRulesLoading = ({ commit }, payload) => {
  commit('SET_RULES_LOADING', payload)
}

export const setPayments = ({ commit }, payload) => {
  commit('SET_PAYMENTS', payload)
}
export const addPayments = ({ commit }, payload) => {
  commit('ADD_PAYMENTS', payload)
}
export const setPaymentsLoading = ({ commit }, payload) => {
  commit('SET_PAYMENTS_LOADING', payload)
}

// Actions
export const setSpreadsSheet = ({ commit }, payload) => {
  commit('SET_SPREADS_SHEET', payload)
}
export const addSpreadsSheet = ({ commit }, payload) => {
  commit('ADD_SPREADS_SHEET', payload)
}
export const setSpreadsSheetLoading = ({ commit }, payload) => {
  commit('SET_SPREADS_SHEET_LOADING', payload)
}

export const setBrokers = ({ commit }, payload) => {
  commit('SET_BROKERS', payload)
}
export const addBrokers = ({ commit }, payload) => {
  commit('ADD_BROKERS', payload)
}
export const setBrokersLoading = ({ commit }, payload) => {
  commit('SET_BROKERS_LOADING', payload)
}
export const setSheetTypes = ({ commit }, payload) => {
  commit('SET_SHEET_TYPES', payload)
}
export const addSheetTypes = ({ commit }, payload) => {
  commit('ADD_SHEET_TYPES', payload)
}
export const setSheetTypesLoading = ({ commit }, payload) => {
  commit('SET_SHEET_TYPES_LOADING', payload)
}

export const setSheetModels = ({ commit }, payload) => {
  commit('SET_SHEET_MODELS', payload)
}
export const addSheetModels = ({ commit }, payload) => {
  commit('ADD_SHEET_MODELS', payload)
}
export const setSheetModelsLoading = ({ commit }, payload) => {
  commit('SET_SHEET_MODELS_LOADING', payload)
}

export const setLists = ({ commit }, payload) => {
  commit('SET_LISTS', payload)
}
export const addLists = ({ commit }, payload) => {
  commit('ADD_LISTS', payload)
}
export const setListsLoading = ({ commit }, payload) => {
  commit('SET_LISTS_LOADING', payload)
}
export const setFechamentos = ({ commit }, payload) => {
  commit('SET_FECHAMENTOS', payload)
}
export const addFechamentos = ({ commit }, payload) => {
  commit('ADD_FECHAMENTOS', payload)
}
export const setFechamentosLoading = ({ commit }, payload) => {
  commit('SET_FECHAMENTOS_LOADING', payload)
}

export const setFilterOptions = ({ commit }, payload) => {
  commit('SET_FILTER_OPTIONS', payload)
}
export const addFilterOptions = ({ commit }, payload) => {
  commit('ADD_FILTER_OPTIONS', payload)
}
export const setFilterOptionsLoading = ({ commit }, payload) => {
  commit('SET_FILTER_OPTIONS_LOADING', payload)
}

export const setMinimoGarantido = ({ commit }, payload) => {
  commit('SET_MINIMO_GARANTIDO', payload)
}
export const addMinimoGarantido = ({ commit }, payload) => {
  commit('ADD_MINIMO_GARANTIDO', payload)
}
export const setMinimoGarantidoLoading = ({ commit }, payload) => {
  commit('SET_MINIMO_GARANTIDO_LOADING', payload)
}

export const setManualAdjustments = ({ commit }, payload) => {
  commit('SET_MANUAL_ADJUSTMENTS', payload)
}
export const addManualAdjustments = ({ commit }, payload) => {
  commit('ADD_MANUAL_ADJUSTMENTS', payload)
}
export const setManualAdjustmentsLoading = ({ commit }, payload) => {
  commit('SET_MANUAL_ADJUSTMENTS_LOADING', payload)
}

export const setFieldChange = ({ commit }, payload) => {
  commit('SET_FIELD_CHANGE', payload)
}
export const addFieldChange = ({ commit }, payload) => {
  commit('ADD_FIELD_CHANGE', payload)
}
export const setFieldChangeLoading = ({ commit }, payload) => {
  commit('SET_FIELD_CHANGE_LOADING', payload)
}

export const setFilterOptionsRules = ({ commit }, payload) => {
  commit('SET_FILTER_OPTIONS_RULES', payload)
}
export const addFilterOptionsRules = ({ commit }, payload) => {
  commit('ADD_FILTER_OPTIONS_RULES', payload)
}
export const setFilterOptionsRulesLoading = ({ commit }, payload) => {
  commit('SET_FILTER_OPTIONS_RULES_LOADING', payload)
}

export const setPaymentsGroups = ({ commit }, payload) => {
  commit('SET_PAYMENTS_GROUPS', payload)
}
export const setPaymentsGroupsRefDate = ({ commit }, payload) => {
  commit('SET_PAYMENTS_GROUPS_REF_DATE', payload)
}
export const setPaymentsGroupsLoading = ({ commit }, payload) => {
  commit('SET_PAYMENTS_GROUPS_LOADING', payload)
}
export const setPaymentGroupNames = ({ commit }, payload) => {
  commit('SET_PAYMENT_GROUP_NAMES', payload)
}
export const setPaymentGroupNamesLoading = ({ commit }, payload) => {
  commit('SET_PAYMENT_GROUP_NAMES_LOADING', payload)
}
export const setAprovacaoProfissional = ({ commit }, payload) => {
  commit('SET_APROVACAO_PROFISSIONAL', payload)
}
export const addAprovacaoProfissional = ({ commit }, payload) => {
  commit('ADD_APROVACAO_PROFISSIONAL', payload)
}
export const setAprovacaoProfissionalLoading = ({ commit }, payload) => {
  commit('SET_APROVACAO_PROFISSIONAL_LOADING', payload)
}

export const setSummaryOverview = ({ commit }, payload) => {
  commit('SET_SUMMARY_OVERVIEW', payload)
}
export const addSummaryOverview = ({ commit }, payload) => {
  commit('ADD_SUMMARY_OVERVIEW', payload)
}
export const setSummaryOverviewLoading = ({ commit }, payload) => {
  commit('SET_SUMMARY_OVERVIEW_LOADING', payload)
}

export const setRevenueHistory = ({ commit }, payload) => {
  commit('SET_REVENUE_HISTORY', payload)
}
export const addRevenueHistory = ({ commit }, payload) => {
  commit('ADD_REVENUE_HISTORY', payload)
}
export const setRevenueHistoryLoading = ({ commit }, payload) => {
  commit('SET_REVENUE_HISTORY_LOADING', payload)
}

export const setCommissions = ({ commit }, payload) => {
  commit('SET_COMMISSIONS', payload)
}
export const addCommissions = ({ commit }, payload) => {
  commit('ADD_COMMISSIONS', payload)
}
export const setCommissionsLoading = ({ commit }, payload) => {
  commit('SET_COMMISSIONS_LOADING', payload)
}

export const setCommissionsDetails = ({ commit }, payload) => {
  commit('SET_COMMISSIONS_DETAILS', payload)
}
export const addCommissionsDetails = ({ commit }, payload) => {
  commit('ADD_COMMISSIONS_DETAILS', payload)
}
export const setCommissionsDetailsLoading = ({ commit }, payload) => {
  commit('SET_COMMISSIONS_DETAILS_LOADING', payload)
}

export const setRevenueOverview = ({ commit }, payload) => {
  commit('SET_REVENUE_OVERVIEW', payload)
}
export const addRevenueOverview = ({ commit }, payload) => {
  commit('ADD_REVENUE_OVERVIEW', payload)
}
export const setRevenueOverviewLoading = ({ commit }, payload) => {
  commit('SET_REVENUE_OVERVIEW_LOADING', payload)
}

export const setRevenueOverviewDetails = ({ commit }, payload) => {
  commit('SET_REVENUE_OVERVIEW_DETAILS', payload)
}
export const addRevenueOverviewDetails = ({ commit }, payload) => {
  commit('ADD_REVENUE_OVERVIEW_DETAILS', payload)
}
export const setRevenueOverviewDetailsLoading = ({ commit }, payload) => {
  commit('SET_REVENUE_OVERVIEW_DETAILS_LOADING', payload)
}

export const setGeneralData = ({ commit }, payload) => {
  commit('SET_GENERAL_DATA', payload)
}
export const addGeneralData = ({ commit }, payload) => {
  commit('ADD_GENERAL_DATA', payload)
}
export const setRoaData = ({ commit }, payload) => {
  commit('SET_ROA_DATA', payload)
}
export const setRoaDataLoading = ({ commit }, payload) => {
  commit('SET_ROA_DATA_LOADING', payload)
}
export const setRoaCompetencias = ({ commit }, payload) => {
  commit('SET_ROA_COMPETENCIAS', payload)
}
export const setRoaCompetenciasLoading = ({ commit }, payload) => {
  commit('SET_ROA_COMPETENCIAS_LOADING', payload)
}
export const setGeneralDataLoading = ({ commit }, payload) => {
  commit('SET_GENERAL_DATA_LOADING', payload)
}

export const setClientAnalysis = ({ commit }, payload) => {
  commit('SET_CLIENT_ANALYSIS', payload)
}
export const addClientAnalysis = ({ commit }, payload) => {
  commit('ADD_CLIENT_ANALYSIS', payload)
}
export const setClientAnalysisLoading = ({ commit }, payload) => {
  commit('SET_CLIENT_ANALYSIS_LOADING', payload)
}

export const setResultsByAdvisor = ({ commit }, payload) => {
  commit('SET_RESULTS_BY_ADVISOR', payload)
}
export const addResultsByAdvisor = ({ commit }, payload) => {
  commit('ADD_RESULTS_BY_ADVISOR', payload)
}
export const setResultsByAdvisorLoading = ({ commit }, payload) => {
  commit('SET_RESULTS_BY_ADVISOR_LOADING', payload)
}

export const setResultsByCategories = ({ commit }, payload) => {
  commit('SET_RESULTS_BY_CATEGORIES', payload)
}
export const addResultsByCategories = ({ commit }, payload) => {
  commit('ADD_RESULTS_BY_CATEGORIES', payload)
}
export const setResultsByCategoriesLoading = ({ commit }, payload) => {
  commit('SET_RESULTS_BY_CATEGORIES_LOADING', payload)
}

export const setComentarios = ({ commit }, payload) => {
  commit('SET_COMENTARIOS', payload)
}
export const addComentarios = ({ commit }, payload) => {
  commit('ADD_COMENTARIOS', payload)
}
export const setComentariosLoading = ({ commit }, payload) => {
  commit('SET_COMENTARIOS_LOADING', payload)
}

export const setSelectedFilters = ({ commit }, payload) => {
  commit('SET_SELECTED_FILTERS', payload)
}
export const setExportPayments = ({ commit }, payload) => {
  commit('SET_EXPORT_PAYMENTS', payload)
}
export const addExportPayments = ({ commit }, payload) => {
  commit('ADD_EXPORT_PAYMENTS', payload)
}
export const setExportPaymentsLoading = ({ commit }, payload) => {
  commit('SET_EXPORT_PAYMENTS_LOADING', payload)
}

export const setDadosIndicadores = ({ commit }, payload) => {
  commit('SET_DADOS_INDICADORES', payload)
}
export const addDadosIndicadores = ({ commit }, payload) => {
  commit('ADD_DADOS_INDICADORES', payload)
}
export const setDadosIndicadoresLoading = ({ commit }, payload) => {
  commit('SET_DADOS_INDICADORES_LOADING', payload)
}

export const setDadosProfissionais = ({ commit }, payload) => {
  commit('SET_DADOS_PROFISSIONAIS', payload)
}
export const setDadosProfissionaisLoading = ({ commit }, payload) => {
  commit('SET_DADOS_PROFISSIONAIS_LOADING', payload)
}

export const setDadosCategorias = ({ commit }, payload) => {
  commit('SET_DADOS_CATEGORIAS', payload)
}
export const setDadosCategoriasLoading = ({ commit }, payload) => {
  commit('SET_DADOS_CATEGORIAS_LOADING', payload)
}

export const setReferenceBase = ({ commit }, payload) => {
  commit('SET_REFERENCE_BASE', payload)
}
export const addReferenceBase = ({ commit }, payload) => {
  commit('ADD_REFERENCE_BASE', payload)
}
export const setReferenceBaseLoading = ({ commit }, payload) => {
  commit('SET_REFERENCE_BASE_LOADING', payload)
}

// Resolve o escritório em visualização. O time interno (admin) alterna entre
// escritórios no mesmo navegador e o localStorage é por navegador — carimbar/validar
// o escritório evita que os filtros de um escritório vazem para outro. CU-86aajcqwx.
const getIdEscritorioAtual = (rootGetters) => {
  const user = rootGetters['user/currentUser'] || {}
  // `|| null` coage id_interno ausente/0 a null: assim um carimbo "vazio" nunca
  // casa com outro "vazio" no load, fechando a borda undefined === undefined.
  return user.escritorio ? user.escritorio.id_interno || null : null
}

export const setLocalFilters = ({ commit, rootGetters }, payload) => {
  commit('SET_LOCAL_FILTERS', {
    filters: payload,
    idEscritorio: getIdEscritorioAtual(rootGetters),
  })
}

export const loadLocalFiltersFromStorage = ({ commit, rootGetters }) => {
  commit('LOAD_LOCAL_FILTERS_FROM_STORAGE', getIdEscritorioAtual(rootGetters))
}
export const setBaseClientes = ({ commit }, payload) => {
  commit('SET_BASE_CLIENTES', payload)
}
export const addBaseClientes = ({ commit }, payload) => {
  commit('ADD_BASE_CLIENTES', payload)
}
export const removeClient = ({ commit }, payload) => {
  commit('REMOVE_CLIENT', payload)
}
export const setBaseClientesLoading = ({ commit }, payload) => {
  commit('SET_BASE_CLIENTES_LOADING', payload)
}

export const setGatilhosPerformance = ({ commit }, payload) => {
  commit('SET_GATILHOS_PERFORMANCE', payload)
}
export const addGatilhosPerformance = ({ commit }, payload) => {
  commit('ADD_GATILHOS_PERFORMANCE', payload)
}
export const setGatilhosPerformanceLoading = ({ commit }, payload) => {
  commit('SET_GATILHOS_PERFORMANCE_LOADING', payload)
}
export const setGatilhosIndicadores = ({ commit }, payload) => {
  commit('SET_GATILHOS_INDICADORES', payload)
}
export const addGatilhosIndicadores = ({ commit }, payload) => {
  commit('ADD_GATILHOS_INDICADORES', payload)
}
export const setGatilhosIndicadoresLoading = ({ commit }, payload) => {
  commit('SET_GATILHOS_INDICADORES_LOADING', payload)
}
export const setGatilhosIndicadoresResultados = ({ commit }, payload) => {
  commit('SET_GATILHOS_INDICADORES_RESULTADOS', payload)
}
